import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Page } from '../../../contexts/kioskConfiguration/type';
import { SignpostTemplate, SignpostTemplateType } from '../signpost/SignpostTemplate';
import {
  setFetchedTransportation,
  setTransportationForm, transportationFormInitialState
} from '../../../store/slices/transportation/transportationSlice';
import { RootState } from '../../../store/store';


type Props = {
  page: Page<SignpostTemplateType>
}

export const LoadingSignpostTemplate = (props: Props): React.ReactElement => {
  const dispatch = useDispatch()
  const transportationForm = useSelector((state: RootState) => state.transportation.transportationForm)

  useEffect(() => {
    dispatch(setFetchedTransportation(null))
    dispatch(setTransportationForm({
      ...transportationFormInitialState,
      distance: transportationForm.distance,
    }))
  }, []);

  return (
    <SignpostTemplate page={props.page} />
  )
}
